<template>
  <div class="el-col-24">
    <h5 class="warp-title">分时咨询统计</h5>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline search" size="small">
      <!-- <el-form-item label="用户ID">
        <el-input v-model="searchForm.userId" placeholder="请输入用户ID"></el-input>
      </el-form-item> -->
      <el-form-item label="开始时间">
        <el-date-picker
          @change="changeDatePicker"
          v-model="searchForm.startDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="请选择开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          @change="changeDatePicker"
          value-format="yyyy-MM-dd"
          v-model="searchForm.endDate"
          type="date"
          placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-radio-group @change="changeDate" v-model="searchForm.queryType" size="small">
          <el-radio-button :label="2">近30天</el-radio-button>
          <el-radio-button :label="1">近7天</el-radio-button>
          <el-radio-button :label="0">今天</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button l-button type="primary" @click="onSubmit" :loading="isSearchLoading">查询</el-button>
        <el-button l-button @click="export1" :loading="isExportLoading">导出</el-button>
      </el-form-item>
    </el-form>
    <div id="myChart"></div>
  </div>
</template>

<script>
import {queryLoginLogoutRecordCountList, loginLogoutRecordCountListExport} from '../../api/statistics/index'
export default {
  name: 'Problem',
  data () {
    return {
      isExportLoading: false,
      isSearchLoading: false,
      searchForm: {
        queryType: 0,
        userId: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  methods: {
    export1 () {
      this.isExportLoading = true
      loginLogoutRecordCountListExport(this.searchForm).then(res => {
        this.isExportLoading = false
        if (res.data.resultCode === 0) {
          window.open(res.data.resultData.fileDownLoadUrl)
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    },
    changeDatePicker () {
      this.searchForm.queryType = ''
    },
    changeDate () {
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
    },
    onSubmit () {
      this.initData()
    },
    initData () {
      this.isSearchLoading = true
      queryLoginLogoutRecordCountList(this.searchForm).then(res => {
        this.isSearchLoading = false
        if (res.data.resultCode === 0) {
          this.drawChart(res.data.resultData)
        } else {
          this.drawChart([])
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    drawChart (resultData) {
      let xAxisData = resultData.map(item => {
        return item.hour
      })
      let countData = resultData.map(item => {
        return item.count
      })
      let option = {
        // backgroundColor: '#FFF0F5',
        title: {
          x: 'center'
        },
        legend: {
          // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
          orient: 'horizontal',
          // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: 'left',
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: 'top'
          // data: ['预期', '实际', '假设']
        },
        //  图表距边框的距离,可选值：'百分比'¦ {number}（单位px）
        grid: {
          top: '16%', // 等价于 y: '16%'
          left: '3%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        // 提示框
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          name: '小时',
          type: 'category',
          axisLine: {
            lineStyle: {
              // 设置x轴颜色
              // color: '#912CEE'
            }
          },
          // 设置X轴数据旋转倾斜
          axisLabel: {
            rotate: 30, // 旋转角度
            interval: 0 // 设置X轴数据间隔几个显示一个，为0表示都显示
          },
          // boundaryGap值为false的时候，折线第一个点在y轴上
          boundaryGap: false,
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          data: xAxisData // x轴数据
        },
        yAxis: {
          name: '用户数',
          type: 'value',
          min: 0, // 设置y轴刻度的最小值
          // max: 20000, // 设置y轴刻度的最大值
          splitNumber: 9, // 设置y轴刻度间隔个数
          axisLine: {
            lineStyle: {
              // 设置y轴颜色
              // color: '#87CEFA'
            }
          }
        },
        series: [
          {
            name: '用户数',
            data: countData,
            type: 'line',
            // 设置折线上圆点大小
            symbolSize: 10,
            // 设置拐点为实心圆
            symbol: 'circle',
            itemStyle: {
              normal: {
                // 拐点上显示数值
                label: {
                  show: true
                },
                lineStyle: {
                  // 使用rgba设置折线透明度为0，可以视觉上隐藏折线
                  color: '#409eff'
                }
              }
            }
          }
        ]
        // color: ['#00EE00', '#FF9F7F', '#FFD700']
      }
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.setOption(option)
    }
  }
}
</script>

<style>
#myChart{
  /* width: 400px; */
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/Consult.vue